<template>
    <df-exam :steps="getSteps()" :input="loadCheckData(assessment)" disabled/>
</template>
<script>
    import Assessment from '../../../models/Assessment';

    import check from '../../../mixins/check';
    import DfExam from '../../blocks/DfExam';

    export default {
        mixins: [check],
        components: { DfExam },

        props: {
            assessment: Assessment,
        },

        methods: {
            getSteps() {
                return [
                    { label: 'Organisation', component: () => import('../check/01-Organisation') },
                    { label: 'Auftraggeber', component: () => import('../check/02-Contact') },
                    { label: 'Eigenschaften', component: () => import('../check/03-Properties') },
                    { label: 'Systeme', component: () => import('../check/04-Software') },
                    { label: 'Prozesse', component: () => import('../check/05-Processes') },
                ];
            },
        },
    };
</script>
